import type { IconSvgObject } from './types';

const VolumeMute01Icon: IconSvgObject = [
  ["path", { d: "M11 8.5H8C6.89543 8.5 6 9.39543 6 10.5V13.5C6 14.6046 6.89543 15.5 8 15.5H11L18 20V4L11 8.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default VolumeMute01Icon;
